module.exports = __webpack_public_path__ + "images/pages/lp/estimate_process_3_90bc2a6d39b56546cfd8727f70d74187.png";